package com.zq.webproject.model

import kotlinx.serialization.Serializable

/**
 * 银行卡数据模型
 */
@Serializable
data class BankCard(
    val id: Int? = null,                      // 银行卡ID（可能为null）
    val userId: Int? = null,                  // 用户ID（可能为null）
    val cardNumber: String,                   // 银行卡号
    val cardHolderName: String,               // 持卡人姓名
    val expirationDate: String,               // 有效期
    val cvv: String? = null,                  // CVV安全码（可能为null，出于安全考虑）
    val bankName: String                      // 银行名称
)

/**
 * 添加银行卡响应
 */
@Serializable
data class AddBankCardResponse(
    val success: Boolean,
    val message: String,
    val bankCard: BankCard? = null
)